const BaseInfo = `
  id,
  name
`;

const BaseLabelsFilters = `state: \"approved\", isPublic: true, labelTypes: [\"target\", \"spotlight\", \"personality\"]`;

const LabelFieldsFragmentInfo = `
  ${BaseInfo},
  labelType
`;

const LabelParentInfo = `
  parentLabel{
    id
  }
`;

const getChildLabels = (labelId, parentId) => {
  return {
    query: `{
      labelViewerLabels: weightedLabels (parentId: ${labelId}) {
        childId,
        childLabel (${BaseLabelsFilters}) {
          ${LabelFieldsFragmentInfo},
          ${LabelParentInfo}
        }
      },
      labelDetails: label (id: ${labelId}) {
        ${LabelFieldsFragmentInfo},
        state,
        isPublic,
        parentLabels (${BaseLabelsFilters}) {
          ${BaseInfo},
        }
      },
      labelParents: label (id: ${labelId}, ${BaseLabelsFilters}) {
        ${BaseInfo},
        ${RelatedParentsQuery(parentId)}
      }
    }`
  };
}

const getTier1Labels = (labelId, parentId) => {
  return { query: `{
      labelViewerLabels: labels (tier1: true) {
        ${LabelFieldsFragmentInfo},
        ${LabelParentInfo}
      },
      labelParents: label (id: ${labelId}, ${BaseLabelsFilters}) {
        ${BaseInfo},
        ${RelatedParentsQuery(parentId)}
      },
      labelDetails: label (id: ${labelId}) {
        ${LabelFieldsFragmentInfo},
        state,
        isPublic,
        parentLabels (${BaseLabelsFilters}) {
          ${BaseInfo},
        }
      }
    }`
  }
}

const getLabelsByName = (name) => {
  return { query: `{
      filteredLabels: labels (first: 60, like: {name: "%${name}%"}, ${BaseLabelsFilters}) {
        ${LabelFieldsFragmentInfo}, parentLabel {id}
      }
    }`
  }
}

const ParentTreeQuery = (iteration) => {
  return `parentLabel {
    ${iteration > 0 ? ParentTreeQuery(--iteration) + ',' : ''}
    ${BaseInfo}
  }`
}

const RelatedParentsQuery = (parentId) => {
  if (parentId) {
    return `parentLabel: weightedParentLabel (parentId: ${parentId}) {
      ${ParentTreeQuery(6)}
    }`;
  } else {
    return `${ParentTreeQuery(6)}`;
  }
}

const getParentsLabelQuery = (labelId, parentId) => {
  return { query: `{
      labelParents: label (id: ${labelId}, ${BaseLabelsFilters}) {
        ${BaseInfo},
        ${RelatedParentsQuery(parentId)}
      }
    }`
  };
}

/** Query section commented due to replacement of the forecast model
const labelForecasting = `
  labelForecasting: forecasting (group: [\"groupByDummy\"]) {
    labelBidReq: func(field:\"impressions\", op:\"sum\"),
    label{ id }
  }
`;
*/

const getLabelDetails = (labelId) => {
  return { query: `{
      labelDetails: label (id: ${labelId}) {
        ${LabelFieldsFragmentInfo},
        state,
        isPublic,
        parentLabels (${BaseLabelsFilters}) {
          ${BaseInfo},
        }
      }
    }`
  }
}

export default {
  getChildLabels,
  getTier1Labels,
  getLabelsByName,
  getParentsLabelQuery,
  getLabelDetails
}



// WEBPACK FOOTER //
// ./src/components/labelViewer/labelViewer.query.jsx